export default `
<svg
  aria-hidden="true"
  aria-label="file-pen"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M5.77809 17.6875H11.2929L11.1512 18.2398C11.0873 18.4969 11.1012 18.7594 11.1901 19H5.77809C4.79736 19 4 18.2152 4 17.25V6.75C4 5.78477 4.79736 5 5.77809 5H10.3761C10.8484 5 11.3013 5.1832 11.6347 5.51133L14.149 7.98594C14.4824 8.31406 14.6685 8.75977 14.6685 9.22461V13.1922L13.335 14.5047V9.375H11.1123C10.6206 9.375 10.2233 8.98398 10.2233 8.5V6.3125H5.77809C5.5336 6.3125 5.33356 6.50937 5.33356 6.75V17.25C5.33356 17.4906 5.5336 17.6875 5.77809 17.6875ZM19.2749 11.4449L19.6749 11.8387C20.1084 12.2652 20.1084 12.957 19.6749 13.3863L18.8581 14.1902L16.8856 12.2488L17.7024 11.4449C18.1358 11.0184 18.8387 11.0184 19.2749 11.4449ZM12.6654 16.4023L16.2549 12.8695L18.2275 14.8109L14.638 18.341C14.524 18.4531 14.3824 18.5324 14.224 18.5707L12.5543 18.9809C12.4015 19.0191 12.2431 18.9754 12.132 18.866C12.0208 18.7566 11.9764 18.6008 12.0153 18.4504L12.432 16.807C12.4709 16.6539 12.5515 16.5117 12.6654 16.3996V16.4023Z"
    fill="currentcolor"
  />
</svg>
`;
